<template>

    <div>
        <div class="box box-solid">
            <div class="box-header">
                <div class="box-tools">
                    <label>
                        Periode
                        <date-picker
                            v-model="filters.range"
                            format="DD-MM-YYYY"
                            range
                            @change="applyFilters()"
                        ></date-picker>
                    </label>

                    <label>
                        Status
                        <v-select
                            v-model="filters.active"
                            :options="[{value: 1, label: 'Actief'}, {value: 0, label: 'Inactief'}]"
                            :reduce="status => status.value"
                            @input="applyFilters()"
                        />
                    </label>

                    <label>
                        Team
                        <v-select
                            v-model="filters.team"
                            :options="teams"
                            :reduce="team => team.id"
                            label="name"
                            @input="applyFilters()"
                        />
                    </label>

                    <button
                        class="btn btn-default btn-sm"
                        type="button"
                        v-tooltip="'Exporteer naar PDF'"
                        @click="exportToPdf()"
                    >
                        <i class="mdi mdi-file-pdf-box"></i>
                    </button>
                </div>
            </div>
            <div class="box-body" style="min-height:200px;">
                <div v-if="loaded">
                    <gantt-tasks
                        :tasks="tasks"
                        :range="range"
                        :show-budget="showBudget"
                        :show-buttons="showButtons"
                        @task-clicked="onTaskClick"
                        @task-dblclick="onTaskDblclick"
                        @updated-task-percentage="onTaskPercentageUpdate"
                    ></gantt-tasks>
                </div>
            </div>
            <div class="overlay" v-show="!loaded || loading">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <tasks-form-modal
            v-if="projectUuid !== null && dataLoaded"
            :new-task-post-uri="newTaskPostUri"
            :project-uuid="projectUuid"
            :can-edit-finance="showBudget"
        ></tasks-form-modal>
        <div class="modal fade" id="disableTaskModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="mdi mdi-close"></i></span></button>
                        <h4 class="modal-title">{{ lang.get('tasks.disabletask.title') }}</h4>
                    </div>
                    <div class="modal-body">
                        <p v-html="lang.get('tasks.disabletask.body')"></p>
                        <div class="form-group">
                            <div class="checkbox">
                                <label>
                                    <input type="checkbox" v-model='disableTaskData.deleteplannedusers'>
                                    {{ lang.get('tasks.disabletask.deleteplanned') }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="row">
                            <div class="col-sm-6 text-left">
                                <button @click="close()" class="btn btn-sm btn-default">{{ lang.get("global.no") }}</button>
                            </div>
                            <div class="col-sm-6">
                                <button @click="fireDisableTask()" class="btn btn-sm btn-primary">{{ lang.get("global.yes") }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import GanttTasks from '../Gantt/Tasks';
import Hub from '../../Hub';
import TasksFormModal from './Sections/FormModal';
import Lang from '../../Lang';
import moment from 'moment';
import DatePicker from "vue2-datepicker";
import vSelect from "vue-select";

export default {

    components: {
        GanttTasks,
        TasksFormModal,
        DatePicker,
        vSelect,
    },

    computed: {
        ...mapGetters([
            "dataLoaded",
            "getRoutes",
        ]),
    },

    data() {
        return {
            disableTaskData: {
                deleteplannedusers:false,
                task_id:null,
            },

            lang:Lang,
            loaded:false,
            loading:false,
            range:[],
            tasks: {
                data: [],
            },

            modal: {
                create:false,
                show:false,
                task_id:null,
                task:null,
            },
            teams: [],
            filters: {
                range: null,
                active: 1,
                team: null,
            }

        }
    },

    destroyed() {
        Hub.$off('finalize-task-delete', this.finalizeTaskDeletion);
        Hub.$off('add-task-to-gantt-object', this.addTaskToGanttObject);
        Hub.$off('update-task-in-gantt-object', this.updateTaskInGanttObject);
    },

    methods: {
        ...mapActions([
            'parseData',
        ]),

        close() {
            $('#disableTaskModal').modal('hide');
            this.disableTaskData.deleteplannedusers = false;
            this.disableTaskData.task_id = null;
        },

        exportToPdf() {
            name = 'tasks-' + moment().format('YYYY-MM-DD-HH-mm') + '.pdf';
            gantt.exportToPDF({'name': name});
        },
        /*
         |
         | This method is basically a base JS method that checks which target element has been clicked on,
         | dispatching the proper method as a result. Be careful what you change here.
         |
         */
        onTaskClick(task_id, obj) {
            if (!obj.target || obj.target.classList.length === 0 || this.showButtons === false) {
                // Simply return false;
                return false;
            }
            // Store classlist
            let classList = obj.target.classList;
            // Set actions
            // Deletion
            if (classList.contains("fa-times")) {
                this.deleteTask(task_id);
            }
            // Creation
            if (classList.contains("fa-plus")) {
                this.createTask(task_id);
            }
            // Enable
            if (classList.contains("fa-toggle-off")) {
                this.enableTask(task_id);
            }
            // Disable
            if (classList.contains("fa-toggle-on")) {
                this.disableTask(task_id);
            }
        },

        onTaskDblclick(task_id, obj) {
            // Check task_id first. This can be null.
            if (task_id === null || this.showButtons === false) {
                return false;
            }
            // Get the task
            let task = gantt.getTask(task_id);
            // Check if its a project
            if (task.is_project) {
                return false;
            }
            // Set modal
            this.modal = {
                create:false,
                show:true,
                task_id:task_id,
                task:task,
            };
            // Open the modal
            Hub.$emit("open-task-edit-modal", task_id);
        },

        onTaskPercentageUpdate(task_id, obj) {
            // Check task_id first. This can be null.
            if (task_id === null) {
                return false;
            }
            // Get the task
            let task = gantt.getTask(task_id);
            // Patch the request
            axios.patch(this.route('api.v1.tasks.updatecompletion'), {
                    task_uuid: task_id,
                    progress: task.progress
                });
            // Update the parent completion
            this.updateParentCompletion(task.parent);
        },

        updateParentCompletion(task_id) {
            /*
             |
             | So normally we would use gantt's 'getSiblings' method to get the siblings of the parent. This method however
             | doesn't always return the attached siblings, resulting in incorrect data.
             |
             */
            // Get parent
            let parent = gantt.getTask(task_id);
            // Setup counter
            let totalduration = 0;
            let totalcompletion = 0;
            // Loop all tasks
            gantt.eachTask((task) => {
                // Skip the current parent
                if (task.id === parent.id) {
                    return true;
                }
                // Increase duration
                totalduration += task.duration;
                // Increase completion
                totalcompletion += (task.progress * task.duration);
            });
            // Set progress
            parent.progress = (totalcompletion / totalduration);
            // Update the parent entry
            gantt.updateTask(task_id);
        },

        getTasks() {
            // Make the call
            axios.get(this.tasksUri)
            .then((response) => {
                this.range = response.data.data.range;
                // #684
                this.tasks.data = response.data.data.tasks.map(task => {
                    task.end_date = moment(task.end_date).add(1, 'day').format('YYYY-MM-DD');
                    return task;
                });
                this.loaded = true;
            });
        },

        createTask(parent_id) {
            Hub.$emit("open-task-add-modal", parent_id);
        },

        deleteTask(task_id) {
            // Make sure task_id is not null
            if (null === task_id) {
                return;
            }
            // Get the task
            let task = gantt.getTask(task_id);
            // Fire an event to show the removal modal
            Hub.$emit(
                "show-remove-confirmation-modal",
                "Taak verwijderen",
                "Weet je zeker dat je taak '" + task.text + "' wilt verwijderen? Alle gekoppelde data zal worden verwijderd.",
                "finalize-task-delete",
                task_id
            );
        },

        enableTask(task_id) {
            this.toggleActive(task_id);
        },

        disableTask(task_id) {
            $('#disableTaskModal').modal('show');
            this.disableTaskData.task_id = task_id;
        },

        fireDisableTask() {
            let data = JSON.parse(JSON.stringify(this.disableTaskData));
            this.toggleActive(data.task_id, data.deleteplannedusers);
            this.close();
        },

        finalizeTaskDeletion(task_id) {
            // Set loading
            this.loading = true;
            // Make a patch request to the server to delete the task.
            axios.patch(this.route('api.v1.tasks.delete'),{task_uuid: task_id})
            .then(response => {
                // Check response
                if (response.data.success) {
                    // Delete the task from gantt
                    gantt.deleteTask(task_id);
                    // Update loading
                    this.loading = false;
                } else {
                    this.$snotify.error("Er is een fout opgetreden bij het verwijderen van de taak: " + response.data.errorMsg);
                }
            })
            .catch(error => {
                if (error.response && error.response.data.code === 101) {
                    this.$snotify.error("Deze taak kan niet worden verwijderd, omdat er verzonden facturen aan gekoppeld zijn.");
                    this.loading = false;
                } else {
                    this.$snotify.error("Er is een fout opgetreden bij het verwijderen van de taak. Herlaad de pagina s.v.p.");
                }
            });
        },

        toggleActive(task_id, removeplannedusers = false) {
            this.loading = true;
            let data = {task_uuid: task_id};
            if (true === removeplannedusers) {
                data.removeplannedusers = true;
            }
            axios.patch(this.route('api.v1.tasks.toggleactive'), data)
            .then(response => {
                // Check response
                if (response.data.success) {
                    // Get the task
                    let task = gantt.getTask(task_id);
                    // Update the active state
                    task.active = response.data.data.newstatus;
                    // Refresh the data
                    gantt.refreshData();
                } else {
                    this.$snotify.error("Er is een fout opgetreden bij het (de)activeren van de taak: " + response.data.errorMsg);
                }
                // Update loading
                this.loading = false;
            }).catch(() => this.$snotify.error("Er is een fout opgetreden bij het (de)activeren van de taak! Herlaad de pagina s.v.p."));
        },

        addTaskToGanttObject(task) {
            this.loading = true;
            gantt.addTask(task, task.parent);
            this.loading = false;
        },

        updateTaskInGanttObject(task) {
            // Get the task object from gantt
            let org = gantt.getTask(task.id);
            // Loop results
            for (let key in task) {
                if (task.hasOwnProperty(key)) {
                    if (key === "start_date" || key === "end_date") {
                        org[key] = new Date(task[key]);
                    } else {
                        org[key] = task[key];
                    }
                }
            }
            // Update the task
            gantt.updateTask(task.id);
        },

        applyFilters() {
            // This method fires the 'onBeforeTaskDisplay' event which contains the filtering logic.
            gantt.render();
        }

    },

    mounted() {
        this.getTasks();
        this.parseData();
        this.$nextTick(function () {
            Hub.$on('finalize-task-delete', this.finalizeTaskDeletion);
            Hub.$on('add-task-to-gantt-object', this.addTaskToGanttObject);
            Hub.$on('update-task-in-gantt-object', this.updateTaskInGanttObject);
        }.bind(this));

        gantt.attachEvent('onBeforeTaskDisplay', (id, record) => {
            if (record.hasOwnProperty('is_task') && record.is_task) {
                if (this.filters.range) {
                    const rangeStart = this.filters.range[0];
                    const rangeEnd = this.filters.range[1];

                    if (!(record.start_date >= rangeStart && record.end_date <= rangeEnd)) {
                        return false;
                    }
                }

                if (Number.isInteger(this.filters.active) && this.filters.active != record.active) {
                    return false;
                }

                if (this.filters.team && record.team_id != this.filters.team) {
                    return false;
                }
            }

            return true;
        });

        axios.get(this.route('api.v1.hr.teams.index'))
            .then((response) => {
                if (response.status === 200) {
                    this.teams = response.data.data;
                }
            });
    },

    name: "ProjectTasks",

    props: {
        newTaskPostUri: {
            type:String,
            required:true,
        },
        tasksUri: {
            type:String,
            required:true,
        },
        taskUuid: {
            default:null,
        },
        projectUuid: {
            type:String,
            default:null,
        },
        showBudget: {
            type:Boolean,
            default:false,
        },
        showButtons: {
            type:Boolean,
            default:false,
        },
    },

    watch: {
        dataLoaded: function(value) {
            if (value === true) {
                if (this.taskUuid !== null && this.loaded === true) {
                    setTimeout(() => this.onTaskDblclick(this.taskUuid, {}), 500);
                }
            }
        },
    },

}

</script>

<style>
.mx-datepicker {
    width:100%;
}
</style>
